import { en } from './en.i18n'

export const defaultLocale = 'en'

export const translations = { en }
